import { DateCellFormat, minuteToHourConverter } from 'components/DataTableTest'
import round from 'lodash/round'

export const	columns = ({ t }) => {
	const dataTotal = {
		totalSum: 0,
		numberSum: 0,
		productCountSum: 0,
		loyaltyCardCountSum: 0,
		numberEFTSum: 0,
		returnTotalSum: 0,
		orderTotalSum: 0,
		totalTimeSum: 0
	}
	return ([{
		caption: t('statistic_section.strings.date'),
		dataField: 'dateTime',
		width: 170,
		cellRender: DateCellFormat(),
		groupCellRender: DateCellFormat()
	}, {
		caption: t('common.strings.branch'),
		dataField: 'name',
		width: 170
	}, {
		caption: t('common.fields.total_price'),
		dataField: 'total',
		width: 100,
		summary: {
			summaryType: 'sum',
			name: 'totalPrice'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.hourly_turnover'), // Stundenumsatz
		dataField: 'totalPerHour',
		width: 150,
		summary: {
			customizeText: () => dataTotal.perHourTotal && round(dataTotal.perHourTotal, 2)
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.return_rate'), // Retourenquote
		dataField: 'returnRate',
		width: 150,
		customizeText: ({ value }) => value ? `${round(value, 2)}%` : ' ',
		summary: {
			customizeText: () => dataTotal.returnRateTotal && `${round(dataTotal.returnRateTotal, 2)}%`
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.return_value'), // Retourenwert
		dataField: 'returnTotal',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.order_value'), // Bestellwert
		dataField: 'orderTotal',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.number_of_customers'), // Anzahl Kunden
		dataField: 'number',
		width: 150,
		summary: {
			summaryType: 'sum',
			name: 'totalCustomers'
		},
		localFormat: { type: 'float', precision: 0 }
	}, {
		caption: t('statistic_section.strings.revenue_per_customer'), // Umsatz pro Kunde
		dataField: 'incomePerCustomer',
		width: 150,
		calculateCellValue: (data) => {
			dataTotal.totalSum += data.total
			dataTotal.numberSum += data.number
			dataTotal.productCountSum += data.productCount
			dataTotal.loyaltyCardCountSum += data.loyaltyCardCount
			dataTotal.numberEFTSum += data.eftCount
			dataTotal.returnTotalSum += data.returnTotal
			dataTotal.orderTotalSum += data.orderTotal
			dataTotal.totalTimeSum += data.totalTime
			return (data.total && data.number) ? (data.total / data.number) : ''
		},
		summary: {
			calculateCustomSummary: options => {
				const { name, summaryProcess } = options
				if (name === 'incomePerCustomer') {
					if (summaryProcess === 'start') {
						dataTotal.totalSum = 0
						dataTotal.numberSum = 0
						dataTotal.productCountSum = 0
						dataTotal.loyaltyCardCountSum = 0
						dataTotal.numberEFTSum = 0
						dataTotal.returnTotalSum = 0
						dataTotal.orderTotalSum = 0
						dataTotal.totalTimeSum = 0
					}
					if (summaryProcess === 'finalize') {
						if(dataTotal.productCountSum && dataTotal.numberSum) {
							dataTotal.productCountTotal = dataTotal.productCountSum / dataTotal.numberSum
						}
						if(dataTotal.totalSum && dataTotal.productCountSum) {
							dataTotal.perProductCountTotal = dataTotal.totalSum / dataTotal.productCountSum
						}
						if(dataTotal.totalSum && dataTotal.loyaltyCardCountSum) {
							dataTotal.perLoyaltyCardCountTotal = dataTotal.totalSum / dataTotal.loyaltyCardCountSum
						}
						if(dataTotal.totalSum && dataTotal.numberEFTSum) {
							dataTotal.perEftCountTotal = dataTotal.totalSum / dataTotal.numberEFTSum
						}
						if(dataTotal.returnTotalSum && dataTotal.orderTotalSum) {
							dataTotal.returnRateTotal = dataTotal.returnTotalSum / dataTotal.orderTotalSum * 100
						}
						if(dataTotal.totalSum && dataTotal.totalTimeSum) {
							dataTotal.perHourTotal = dataTotal.totalSum / dataTotal.totalTimeSum * 60
						}
						if (dataTotal.totalSum && dataTotal.numberSum) {
							options.totalValue = dataTotal.totalSum / dataTotal.numberSum
						}
					}
				}
			},
			summaryType: 'custom',
			name: 'incomePerCustomer'
		},
		alignment: 'right',
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.number_of_items'), // Anzahl Artikel
		dataField: 'productCount',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.items_per_customer'), // Artikel pro Kunde
		dataField: 'productPerCustomer',
		width: 150,
		localFormat: { type: 'float' },
		summary: {
			customizeText: () => dataTotal.productCountTotal && round(dataTotal.productCountTotal, 2)
		}
	}, {
		caption: t('statistic_section.strings.revenue_per_number_of_items'), // Umsatz pro Anzahl Artikel
		dataField: 'totalPerProductCount',
		width: 150,
		summary: {
			customizeText: () => dataTotal.perProductCountTotal && round(dataTotal.perProductCountTotal, 2)
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.sales_customer_card'), // Umsatz Kundenkarte
		dataField: 'loyaltyCard',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.number_of_customer_cards'), // Anzahl Kundenkarten
		dataField: 'loyaltyCardCount',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float', precision: 0 }
	}, {
		caption: t('statistic_section.strings.sales_per_number_of_customer_cards'), // Umsatz pro Anzahl Kundenkarten
		dataField: 'totalPerLoyaltyCardCount',
		width: 150,
		summary: {
			customizeText: () => dataTotal.perLoyaltyCardCountTotal && round(dataTotal.perLoyaltyCardCountTotal, 2)
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.sales_EFT'), // Umsatz EFT
		dataField: 'eft',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.number_of_EFT'), // Anzahl EFT
		dataField: 'eftCount',
		width: 150,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float', precision: 0 }
	}, {
		caption: t('statistic_section.strings.revenue_per_count_EFT'), // Umsatz pro Anzahl EFT
		dataField: 'totalPerEftCount',
		width: 150,
		summary: {
			customizeText: () => dataTotal.perEftCountTotal && round(dataTotal.perEftCountTotal, 2)
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.staff_hours'), // Personalstunden
		dataField: 'totalTime',
		width: 150,
		cellRender: ({ value }) => value ? minuteToHourConverter(+value) : ' ',
		summary: {
			summaryType: 'sum',
			customizeText: ({ value }) => value ? minuteToHourConverter(+value) : ' '
		}
	}
	])
}
